import { ParsedUrlQuery } from 'querystring'

import {
  useEffect,
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useRef,
} from 'react'

import HomeIcon from '@/public/icons/home_line.svg'
import {
  Button,
  getNavMenuContent,
  NavigationV2Props,
  NavMenuContentType,
} from '@hhgtech/hhg-components'
// import * as Sentry from '@sentry/node'
import { FooterInfoMarryBaby } from '@hhgtech/hhg-components/types'
import { PATHS } from 'api/paths'
import {
  callApi,
  getApiPath,
  callApiWithAuth,
  getSSOPath,
  getTogetherPath,
} from 'api/utils'
import { Container } from 'components'
import { Breadcrumbs } from 'components/atoms/breadcrumbs'
import { Loading } from 'components/atoms/loading'
import { FixedBottomAdBlock } from 'components/molecules/adBlock/fixedBottomAdBlock'
import { Props as ArticleBottomBarProps } from 'components/molecules/articleBottomBar'
import { WeekOfPregnancy } from 'components/molecules/weekOfPregnancy'
import { FeedbackPopup } from 'components/organisms/feedbackPopup'
import { getMetaTag } from 'components/templates/article/utils'
import { NavigatorLayout } from 'components/templates/navigatorLayout'
import { domainLocales } from 'domainLocales'
import { useGetIsMobile } from 'hooks'
import { useCheckCloseBanner } from 'hooks/useCheckCloseBanner'
import { useScreenSize } from 'hooks/useScreenSize'
import innertext from 'innertext'
import debounce from 'lodash/debounce'
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { State } from 'state/types'
import {
  getAdTag,
  getCountryAdTag,
  getLocaleCategoryAdTag,
  getCategorySlugFromArticleSlug,
} from 'utils/ads'
import { cleanLink } from 'utils/htmlHelper'

import {
  formatArticle,
  formatCategory,
  formatCommunity,
  formatHealthTool,
  formatSiteWideBanner,
} from '../../../api/dataTransform'
import { cleanUpUndefined } from '../../../api/dataTransform'
import {
  ArticleType as ArticleConstType,
  FEATURE_FLAG,
  LOCALE_SPECS,
} from '../../../interfaces/constants'
// import { DEFAULT_RESULT_IMG } from '../../../interfaces/constants'
import {
  ArticleApi,
  Article,
  // CategoryApi,
  Category,
  SiteWideBanner,
  HealthTool,
  CommunityApi,
  WeekOfPregnancyApi,
} from '../../../interfaces/types'
import { BaseProps } from '../../../pages/[...slug]'
import { actionTypes } from '../../../state/actionTypes'
import { AppContext } from '../../../state/appContext'
import { isElementScrollPosHigherThanScreen } from '../../../utils/htmlHelper'
import {
  StyledBreadcrumbsWrapper,
  StyledLoadingWrapper,
  StyledArticlePageContainer,
  StyledArticlePageMainWrapper,
  StyledPregnancyArticleTopContainer,
  StyledArticlePageLeftWrapper,
  StyledBottomScrollDetect,
  StyledContentContainer,
} from './index.styled'
import { Props as ArticlePageV2Props } from './indexv2'
import { ArticleMastheadAd } from './MastheadAd'
import { usePromoteArticles } from './promoteArticles'
import {
  fetchArticleRelatedCategories,
  checkInteractionArticle,
  getNextArticle,
  isPreviewSlug,
} from './utils'

export type ArticlePageContextValue = {
  currentArticle?: Article | null
  setCurrentArticle?: Dispatch<SetStateAction<Article | null>>
  setCurrentProgress?: Dispatch<SetStateAction<number>>
  articleFontSize?: string | null
  setChineseTranslate?: Dispatch<SetStateAction<ChineseTranslateEnum>>
  chineseTranslate?: ChineseTranslateEnum
  currentCommentNumber?: number | null
  setCurrentCommentNumber?: Dispatch<SetStateAction<number | null>>
  isUserCommented?: boolean
  setIsUserCommented?: Dispatch<SetStateAction<boolean>>
}
export const ArticlePageContext = createContext<ArticlePageContextValue>({})
const ArticleBottomBar = dynamic<ArticleBottomBarProps>(() =>
  import('components/molecules/articleBottomBar').then(
    (mod) => mod.ArticleBottomBar,
  ),
)
// const ArticlePageV1 = dynamic<ArticlePageV1Props>(() =>
//   import('./indexv1').then((mod) => mod.ArticlePageV1),
// )
const ArticlePageV2 = dynamic<ArticlePageV2Props>(() =>
  import('./indexv2').then((mod) => mod.ArticlePageV2),
)

export type Props = {
  articles: Array<Article>
  categories: Array<Category>
  healthTools: HealthTool[]
  sitewideBanner?: SiteWideBanner | null
  isWeekPregnancyProgressArticle: boolean
  weeksData: WeekOfPregnancyApi[]
  togetherCommunities: CommunityApi[]
  footerMenu: FooterInfoMarryBaby
  activeMenuService?: NavigationV2Props['activeMenuService']
  dataNavMenuContent?: NavMenuContentType | null
} & BaseProps

export enum ChineseTranslateEnum {
  traditional = 0,
  simplified = 1,
}

type FeedbackModalState = {
  isLike: boolean
  id: string | number
}

export const ArticlePageComponent = ({
  articles: propArticles = [],
  categories = [],
  activeMenuService,
  sitewideBanner,
  isWeekPregnancyProgressArticle,
  weeksData,
  dataNavMenuContent,
  footerMenu,
}: Props) => {
  const { state = {} as State, dispatch } = useContext(AppContext)
  const { isMobileSsr, userInfo, isLoggedIn } = state
  const { bookmarks = [] } = userInfo || {}
  const [bookmarkIds, setBookmarkIds] = useState(bookmarks)
  const { isMobile: isMobileCsr } = useScreenSize()
  const router = useRouter()
  const { locale = 'vi-VN' } = router
  const currentDomain = domainLocales[locale || 'vi-VN']
  const currentProtocol =
    typeof window !== 'undefined' ? window.location.protocol : 'https:'

  const isMobile = useGetIsMobile(isMobileSsr, isMobileCsr)
  const [articles, setArticles] = useState<Array<Article>>(propArticles)
  const [loadingMore, setLoadingMore] = useState<boolean>(false)
  const [shouldLoadMore, setShouldLoadMore] = useState(false)
  const [articleFontSize, setArticleFontSize] = useState<string>('small')
  const [currentArticle, setCurrentArticle] = useState<Article | null>(
    articles[0],
  )
  const [isCommentPopupOpen, setIsCommentPopupOpen] = useState(false)
  const [commentCount, setCommentCount] = useState()
  const [currentProgress, setCurrentProgress] = useState(0) // 0 - 1
  const [
    chineseTranslate,
    setChineseTranslate,
  ] = useState<ChineseTranslateEnum>(ChineseTranslateEnum.traditional)

  const [currentCommentNumber, setCurrentCommentNumber] = useState<
    number | null
  >(null)
  const [isUserCommented, setIsUserCommented] = useState<boolean>(false)

  usePromoteArticles({
    locale,
    setArticles,
    articles,
  })

  useEffect(() => {
    if (router?.query?.action === 'comment') {
      setIsCommentPopupOpen(true)
      const query = router?.query
      const { replyID, replyToUsername, replyToUserId } = query
      if (
        typeof localStorage !== 'undefined' &&
        replyID &&
        !Array.isArray(replyID) &&
        replyToUsername &&
        !Array.isArray(replyToUsername) &&
        replyToUserId &&
        !Array.isArray(replyToUserId)
      ) {
        localStorage.setItem('commentArticle', `${currentArticle?.id}`)
        localStorage.setItem('replyingCommentId', replyID)
        localStorage.setItem(
          'replyingAuthor',
          JSON.stringify({
            id: replyToUserId,
            username: replyToUsername,
          }),
        )
        delete query.replyID
        delete query.replyToUsername
        delete query.replyToUserId
      }

      delete query.action
      router.replace({
        href: router.basePath,
        query,
      })
    }
  }, [])

  useEffect(() => {
    setArticles(propArticles)
    setArticleLikeState(null)
    setLoadingMore(false)
    setShouldLoadMore(false)
    setCurrentArticle(propArticles[0])
    setCurrentProgress(0)
    if (!isPreviewSlug())
      router.replace(
        {
          href: router.asPath,
          query: {
            articleId: propArticles[0].id,
            source: router?.query?.source ?? '',
          },
        },
        router.asPath,
        {
          shallow: true,
        },
      )
  }, [propArticles[0].id])

  const [
    feedbackModalState,
    setFeedbackModalState,
  ] = useState<FeedbackModalState | null>(null)
  const ref = useRef<HTMLDivElement>(null)

  const [articleLikeState, setArticleLikeState] = useState<string | null>(null)

  useEffect(() => {
    if (!isPreviewSlug()) {
      const onScroll = debounce(() => {
        if (ref.current) {
          setShouldLoadMore(isElementScrollPosHigherThanScreen(ref.current))
        }
      }, 300)
      document.addEventListener('scroll', onScroll, {
        passive: true,
      })
      return () => document.removeEventListener('scroll', onScroll)
    }
  }, [])

  useEffect(() => {
    router.beforePopState(({ url }) => {
      const baseString = url.split('?')[0]
      const queryString = url.split('?')[1]
      if (baseString === '/[...slug]') {
        const searchParams = new URLSearchParams(queryString)
        //Iterate the search parameters.
        searchParams.forEach((value, key) => {
          if (key === 'articleId') {
            document.getElementById('a-' + value)?.scrollIntoView()
          }
        })
      }
      return true
    })
  }, [])

  const updateLikedDisliked = () => {
    const isLiked = checkInteractionArticle(currentArticle?.id, true)
    const isDisliked = checkInteractionArticle(currentArticle?.id, false)
    if (isLiked) setArticleLikeState('liked')
    else if (isDisliked) setArticleLikeState('disliked')
    else setArticleLikeState(null)
  }
  useEffect(() => {
    updateLikedDisliked()
  }, [currentArticle])

  const failedRef = useRef(0)

  const logoType = LOCALE_SPECS[locale || 'vi-VN'].LOGO_TYPE as any

  useEffect(() => {
    ;(async () => {
      if (shouldLoadMore && !loadingMore && failedRef.current < 3) {
        // Skip all current Article + first 3 related
        try {
          setLoadingMore(true)
          const skipIds = articles
            .reduce<string[]>(
              (r, _article) => r.concat(String(_article.id)),
              [],
            )
            .join(',')

          const lastArticle = articles.slice(-1)[0]

          let prevArticle = lastArticle
          const max = 1
          for (let i = 0; i < max; i++) {
            const newArticle = await getNextArticle({
              article: prevArticle,
              skipIds,
            })
            if (newArticle) {
              failedRef.current = 0
              setArticles((a) => [...a, newArticle])
              if (newArticle.nextArticle) {
                prevArticle = newArticle
              } else {
                break
              }
            } else {
              failedRef.current++
              break
            }
          }
          setTimeout(() => setLoadingMore(false), 500)
        } catch (e) {
          failedRef.current++
          setTimeout(() => setLoadingMore(false), 500)
          // Sentry.captureException(e.message)
        }
      }
    })()
  }, [shouldLoadMore, loadingMore, articles])

  // const useMetaImage =
  //   currentArticle?.metaTag?.image &&
  //   currentArticle?.metaTag?.width > 200 &&
  //   currentArticle?.metaTag?.height > 200

  useEffect(() => {
    if (window.TongWen) {
      setTimeout(() => {
        if (chineseTranslate === ChineseTranslateEnum.traditional) {
          window.TongWen.trans2Trad(document)
        } else {
          window.TongWen.trans2Simp(document)
        }
      }, 500)
    }
  }, [chineseTranslate, articles])

  const isCurrentBookmarked =
    bookmarkIds.indexOf(currentArticle?.id || '') !== -1
  const bookmarkArticle = async () => {
    const { id } = currentArticle || {}
    if (id && userInfo?.id) {
      if (!isCurrentBookmarked) {
        const { _status } = await callApiWithAuth(
          getSSOPath(PATHS.CREATE_BOOKMARK),
          'POST',
          {
            data: {
              host_name: currentDomain.replace('www.', ''),
              post_ids: [id],
            },
          },
        )
        if (_status === 1) {
          setBookmarkIds((b) => b.concat(id))
          dispatch({
            type: actionTypes.ADD_BOOKMARKS,
            payload: {
              bookmarks: [id],
              bookmarkId: id,
            },
          })
        }
      } else {
        const { _status } = await callApiWithAuth(
          getSSOPath(PATHS.DELETE_BOOKMARK),
          'DELETE',
          {
            data: {
              host_name: currentDomain.replace('www.', ''),
              post_ids: [id],
            },
          },
        )
        if (_status === 1) {
          setBookmarkIds((b) => b.filter((bid) => bid !== id))
          dispatch({
            type: actionTypes.REMOVE_BOOKMARKS,
            payload: {
              bookmarks: [id],
              bookmarkId: id,
            },
          })
        }
      }
    } else {
      const currentLocation = window.location.href
      const returnUrlEncode = encodeURIComponent(
        `${currentLocation}${
          currentLocation.includes('?') ? '&' : '?'
        }source=bookmark,${id}`,
      )
      window.location.href = process.env.NEXT_PUBLIC_SSO
        ? `${process.env.NEXT_PUBLIC_SSO}?returnUrl=${returnUrlEncode}`
        : currentLocation
    }
  }

  const login = () => {
    const NEXT_PUBLIC_SSO = process.env.NEXT_PUBLIC_SSO
    const currentLocation = window.location.href
    const returnUrlEncode = encodeURIComponent(
      `${currentLocation}${
        currentLocation.includes('?') ? '&' : '?'
      }source=biodigital`,
    )
    window.location.href = NEXT_PUBLIC_SSO
      ? `${NEXT_PUBLIC_SSO}?returnUrl=${returnUrlEncode}`
      : currentLocation
  }

  useEffect(() => {
    if (!isLoggedIn) {
      const elmParent = (document.getElementById(
        'embedded-human',
      ) as HTMLInputElement)?.parentElement
      elmParent?.setAttribute('style', 'position: relative;z-index: 1;')

      const elmChild = document.getElementById(
        'embedded-human',
      ) as HTMLInputElement
      elmChild?.setAttribute('style', 'position: relative; z-index: -1;')

      elmParent?.addEventListener('mousedown', () => {
        login()
      })
    }
  }, [])

  const handleSelectWeek = debounce((index: number) => {
    router.push(weeksData?.[index]?.recommended_article?.permalink || '')
  }, 700)

  const currentCustomTargetting = {
    Is_Sponsored: [currentArticle?.isSponsored ? 1 : 0],
    Is_Expert_Article: [
      currentArticle?.expert?.id ||
      (currentArticle?.articleReviewed?.expert?.ID &&
        currentArticle?.articleReviewed?.is_author)
        ? 1
        : 0,
    ],
    // Is_Affiliate: [currentArticle?.hasAffiliate ? 1 : 0],
    Keywords: [
      innertext(
        getMetaTag(currentArticle?.metaTag || '', 'content_tags') || '',
      ),
    ],
  }

  const closeSiteWideCookie = useCheckCloseBanner(
    'discover-disable-sitewide-article',
  )

  const adUnitPathCurrentArticle = currentArticle
    ? getAdTag({
        countryAdTag: getCountryAdTag(locale, {
          isMobile,
        }),
        contentAdTag: getLocaleCategoryAdTag(
          locale,
          getCategorySlugFromArticleSlug(currentArticle?.permalink),
        ),
      })
    : ''
  return (
    <>
      <NavigatorLayout
        SEOData={{
          SEOTitle: currentArticle?.postTitle,
          SEOImage: currentArticle?.featureImage,
          apiMetaData: currentArticle?.metaTag,
          isIndexable: true,
          SEODescription: currentArticle?.description,
          seoType: 'article',
        }}
        isMobile={isMobile}
        sitewideBanner={closeSiteWideCookie ? null : sitewideBanner}
        dataNavMenuContent={dataNavMenuContent}
        activeMenuService={activeMenuService}
        footerMenu={footerMenu}
      >
        <Head>
          {locale === 'zh-TW' ? (
            <script
              key="tongwen-translator"
              type="text/javascript"
              src="/libs/tongwen.js"
            />
          ) : null}
          {false &&
          locale === 'id-ID' &&
          !!propArticles[0]?.categories?.find(
            (category) => category?.termId === 68117,
          ) ? (
            <script
              key="tongwen-translator"
              type="text/javascript"
              src="/libs/taboola.js"
            />
          ) : null}
        </Head>
        <ArticlePageContext.Provider
          value={{
            currentArticle,
            setCurrentArticle,
            articleFontSize,
            setCurrentProgress,
            chineseTranslate,
            setChineseTranslate,
            currentCommentNumber,
            setCurrentCommentNumber,
            isUserCommented,
            setIsUserCommented,
          }}
        >
          <ArticleMastheadAd
            article={articles?.[0]}
            defaultNoScroll
            initialSticky
          />
          {isWeekPregnancyProgressArticle && (
            <StyledPregnancyArticleTopContainer>
              <div className="breadcrumb-bg">
                <div className="breadcrumb-container">
                  <Container>
                    <Breadcrumbs
                      className="article-breadcrumb"
                      size="md"
                      pages={[
                        {
                          label: <HomeIcon />,
                          value: '/',
                          dataEventCategory: 'Breadcrumb',
                          dataEventAction: 'Click',
                          dataEventLabel: `https://${domainLocales[locale]}`,
                        },
                        ...categories.map((c) => ({
                          dataEventCategory: 'Breadcrumb',
                          dataEventAction: 'Click',
                          dataEventLabel: `https://${domainLocales[locale]}${c.permalink}`,
                          label: c.displayName || '',
                          value: c.permalink || '',
                        })),
                      ]}
                    />
                  </Container>
                </div>
              </div>
              <WeekOfPregnancy
                data={weeksData}
                onSelectWeek={handleSelectWeek}
                isMobile={isMobile}
                className="week-scroll"
                defaultWeekIndex={weeksData.findIndex(
                  (w) =>
                    w?.recommended_article?.permalink ===
                    articles[0]?.permalink,
                )}
                withStickyScroll={{
                  scrollYFrom: 280,
                }}
              />
            </StyledPregnancyArticleTopContainer>
          )}
          {/* NEED data-sponsored and this class so subot and leadgen can track sponsor */}
          <StyledContentContainer
            data-sponsored={
              currentArticle &&
              currentArticle.isSponsored &&
              currentArticle.sponsor
                ? 'true'
                : ''
            }
            data-sponsored-id={currentArticle?.sponsor?.id || ''}
            className={
              currentArticle &&
              currentArticle.isSponsored &&
              currentArticle.sponsor
                ? 'hhg-disclaimer-text'
                : ''
            }
            id="article-page-container-wrapper"
          >
            <div
              id="article-page-container"
              style={{
                maxWidth: '100%',
              }}
            >
              <StyledArticlePageContainer data-type-mobile={isMobile}>
                <StyledArticlePageLeftWrapper>
                  <FeedbackPopup
                    articleId={feedbackModalState?.id}
                    isLike={feedbackModalState?.isLike}
                    show={!!feedbackModalState?.id}
                    onHidden={() => setFeedbackModalState(null)}
                    onSuccess={updateLikedDisliked}
                  />

                  <ArticleBottomBar
                    progress={currentProgress}
                    liked={articleLikeState === 'liked'}
                    disliked={articleLikeState === 'disliked'}
                    onDislikeClick={() =>
                      currentArticle?.id
                        ? setFeedbackModalState({
                            id: currentArticle.id,
                            isLike: false,
                          })
                        : undefined
                    }
                    onLikeClick={() =>
                      currentArticle?.id
                        ? setFeedbackModalState({
                            id: currentArticle.id,
                            isLike: true,
                          })
                        : undefined
                    }
                    onFontSelect={setArticleFontSize}
                    currentFontSize={articleFontSize}
                    articleUrl={`${currentProtocol}//${currentDomain}${
                      currentArticle?.permalink || articles[0].permalink || ''
                    }`}
                    isMobile={isMobile}
                    ampLogo={logoType}
                    onBookmarkClick={bookmarkArticle}
                    bookmarked={isCurrentBookmarked}
                    commentCount={commentCount}
                    onCommentClick={() => setIsCommentPopupOpen((v) => !v)}
                  />
                </StyledArticlePageLeftWrapper>
                <StyledArticlePageMainWrapper>
                  {!isWeekPregnancyProgressArticle && (
                    <StyledBreadcrumbsWrapper className="breadcrumbs-top">
                      <Breadcrumbs
                        className="article-breadcrumb"
                        size="md"
                        pages={[
                          {
                            label: <HomeIcon />,
                            value: '/',
                            dataEventCategory: 'Breadcrumb',
                            dataEventAction: 'Click',
                            dataEventLabel: `https://${domainLocales[locale]}`,
                          },
                          ...categories.map((c) => ({
                            dataEventCategory: 'Breadcrumb',
                            dataEventAction: 'Click',
                            dataEventLabel: `https://${domainLocales[locale]}${c.permalink}`,
                            label: c.displayName || '',
                            value: c.permalink || '',
                          })),
                        ]}
                      />
                      {locale === 'zh-TW' ? (
                        <Button
                          size="md"
                          color="transparent"
                          className="translate-button"
                          onClick={() => {
                            setChineseTranslate &&
                              setChineseTranslate((v) =>
                                v === ChineseTranslateEnum.simplified
                                  ? ChineseTranslateEnum.traditional
                                  : ChineseTranslateEnum.simplified,
                              )
                          }}
                        >
                          <img
                            loading="lazy"
                            style={{
                              width: 32,
                              height: 32,
                            }}
                            src={
                              chineseTranslate ===
                              ChineseTranslateEnum.simplified
                                ? '/images/ch_traditional.png'
                                : '/images/ch_simplified.png'
                            }
                          />
                        </Button>
                      ) : null}
                    </StyledBreadcrumbsWrapper>
                  )}
                  <ArticlePageV2
                    isMobile={isMobile}
                    articles={articles}
                    commentCount={commentCount}
                    setCommentCount={setCommentCount}
                    isCommentPopupOpen={isCommentPopupOpen}
                    handleCloseCommentPopup={() => setIsCommentPopupOpen(false)}
                    openAskDoctor={() => setIsCommentPopupOpen(true)}
                  />
                  <StyledBottomScrollDetect ref={ref} />
                  <StyledLoadingWrapper data-show={loadingMore}>
                    <Loading />
                  </StyledLoadingWrapper>
                </StyledArticlePageMainWrapper>
                {adUnitPathCurrentArticle && currentArticle ? (
                  <FixedBottomAdBlock
                    key={currentArticle.id + (isMobile ? '-mobile' : '')}
                    divId={`div-gpt-ad-sticky-${currentArticle.id}`}
                    className="article-bottom-ad"
                    adUnitPath={adUnitPathCurrentArticle}
                    isMobile={isMobile}
                    contentId={String(currentArticle?.id)}
                    customTargetings={currentCustomTargetting}
                  />
                ) : null}
              </StyledArticlePageContainer>
            </div>
          </StyledContentContainer>
        </ArticlePageContext.Provider>
      </NavigatorLayout>
    </>
  )
}

type GetArticleServerSideProps<
  P extends { [key: string]: any } = { [key: string]: any },
  Q extends ParsedUrlQuery = ParsedUrlQuery
> = (
  context: GetServerSidePropsContext<Q>,
  articleRes: any,
  userCoral?: { token?: string; isTemp?: boolean },
) => Promise<GetServerSidePropsResult<P>>

export const getServerSideProps: GetArticleServerSideProps<Props> = async (
  { resolvedUrl },
  articleRes,
) => {
  if (articleRes && articleRes.status === 1) {
    const article: ArticleApi = articleRes?.data?.post
    const relatedArticles: Array<ArticleApi> =
      articleRes?.data?.related_articles
    if (!article)
      return {
        notFound: true,
      }

    const permalink = cleanLink(article.permalink)
    const currentLink = cleanLink(resolvedUrl || '')

    if (
      !currentLink.toLowerCase().includes('/preview') &&
      currentLink.toLowerCase() !== permalink.toLowerCase()
    ) {
      // Sentry.captureMessage(currentLink)
      return {
        redirect: {
          destination: article.permalink,
          permanent: true,
        },
      }
    }

    const categorySlugs = article.permalink.split('/').filter(Boolean)
    categorySlugs.pop()

    const newData = formatArticle(article)

    const sitewideBanner = formatSiteWideBanner(
      articleRes?.data?.sitewide_banner as SiteWideBanner,
      'article',
    )

    const [
      // categoriesApi,
      categoriesData,
      relatedCategories,
      healthToolsData,
      togetherCommunitiesRes,
      footer,
      navMenuContent,
    ] = await Promise.all([
      // Promise.all<CategoryApi>(
      //   categorySlugs.map((slug) => {
      //     return callApi(
      //       getApiPath(PATHS.GET_CATEGORY_OR_ARTICLE_DETAIL, {
      //         fullSlug: slug,
      //       }),
      //       'get',
      //     ).then((res) => res?.data?.category)
      //   }),
      // ),
      callApi(getApiPath(PATHS.GET_ALL_CATEGORIES), 'GET'),
      FEATURE_FLAG.articleType === ArticleConstType.ArticleType3
        ? []
        : fetchArticleRelatedCategories(newData),
      callApi(getApiPath(PATHS.GET_ALL_HEALTH_TOOLS), 'GET'),
      callApi(getTogetherPath(PATHS.GET_TOGETHER_COMMUNITY), 'GET'),
      callApi(getApiPath(PATHS.GET_DYNAMIC_FOOTER), 'GET'),
      getNavMenuContent('vi-VN_MB'),
    ])

    // const categories: Category[] = categoriesApi
    //   .filter(Boolean)
    //   .map(formatCategory)

    const topCategories: Category[] =
      categoriesData?.data?.map(formatCategory) ?? []

    const findCategoryBySlug = (
      slugIndex: number,
      slugs: string[],
      categories: Category[],
      returnCategories: Category[],
    ) => {
      const category = categories.find(
        (c) => c.permalink.indexOf(`/${slugs[slugIndex]}`) > -1,
      )

      category && returnCategories.push(category)

      if (category?.childCates?.[0] && slugIndex < slugs.length - 1) {
        findCategoryBySlug(
          slugIndex + 1,
          slugs,
          category.childCates,
          returnCategories,
        )
      }
    }

    const breadCrumbCategories: Category[] = []

    findCategoryBySlug(0, categorySlugs, topCategories, breadCrumbCategories)

    newData.relatedArticles = relatedArticles.map(formatArticle)
    newData.nextArticle = newData.relatedArticles.slice(-1)[0]
    if (newData.nextArticle?.id) {
      newData.relatedArticles = newData.relatedArticles.filter(
        (related) => related.id !== newData.nextArticle?.id,
      )
    }
    newData.relatedCategories = relatedCategories

    const isWeekPregnancyProgressArticle =
      newData.template === 'pregnancy-progression'
    let weeksData: WeekOfPregnancyApi[] = []

    if (isWeekPregnancyProgressArticle) {
      try {
        const res = await callApi(
          getApiPath(PATHS.GET_DUE_DATE_ALL_WEEKS),
          'GET',
        )
        if (res?.data?.results) {
          weeksData = res.data.results
        }
      } catch (e) {}
    }

    return {
      props: {
        page: 'article',
        articles: [newData],
        categories: breadCrumbCategories,
        topCategories,
        healthTools:
          healthToolsData?.data && healthToolsData?.data.length > 0
            ? healthToolsData?.data?.map(formatHealthTool)
            : [],
        sitewideBanner,
        isWeekPregnancyProgressArticle,
        weeksData,
        togetherCommunities: togetherCommunitiesRes?.data?.communities
          ? togetherCommunitiesRes.data.communities.map(formatCommunity)
          : [],
        footerMenu: footer?.data ?? {},
        dataNavMenuContent: cleanUpUndefined(navMenuContent) || null,
      },
    }
  }
  return {
    notFound: true,
  }
}
